<template>
  <button
    type="button"
    aria-label="Back"
    class="flex size-11 shrink-0 cursor-pointer items-center justify-center rounded-full bg-[#fbfbfb]/70 backdrop-blur-xl"
  >
    <span
      class="relative flex size-full items-center justify-center rounded-full"
    >
      <span aria-hidden="true" class="shadow--glass-pill"><i></i></span>
      <ChevronLeftIcon class="size-6 text-gray-800" aria-hidden="true" />
    </span>
  </button>
</template>

<script setup lang="ts">
import { ChevronLeftIcon } from '@dacr/icons'
</script>
